import React from 'react'
import WritingMessageBox from './WritingMessageBox'
import RestofChatScrollable from './RestofChatScrollable'
import './ChatStarted.css'
import classNames from 'classnames';


export default function ChatStarted() {


  const isActive = true;
  const classes = classNames(
    'ecd-flex-grow',
    { 'chatAreaDark': isActive }
  );




  return (
    <div className="ecd-flex-column">
        
            <div className={classes}><RestofChatScrollable></RestofChatScrollable></div>
            <div className=" "><WritingMessageBox></WritingMessageBox></div>

    </div>
  )
}


